module.exports = __webpack_public_path__ + "img/alarm-parameter.04cbef14.svg";